export class DateWrapper {
  static today(): Date {
    return new Date();
  }
}
